import React, { useState, useEffect, FormEvent } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { TextField, Input, Button, Select, MenuItem } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import BackIcon from '@material-ui/icons/ArrowBack';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddIcon from '@material-ui/icons/Add';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';

import api from '../../../../services/api';
import './styles.scss';
import { Action, Resource } from '../../../../utils/aclUtils';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
        width: '100%',
      },
    },
    grid: {
      display: 'flex',
      '@media screen and (max-width: 991px)': {
        display: 'block',
      },
      '& > *': {
        margin: theme.spacing(1),
        width: '100%',
        '@media screen and (max-width: 991px)': {
          width: '100%',
        }
      },
    },
    grid2: {
      display: 'flex',
      '@media screen and (max-width: 991px)': {
        display: 'block',
      },
      '& > *': {
        margin: theme.spacing(1),
        width: '50%',
        '@media screen and (max-width: 991px)': {
          width: '100%',
        }
      },
    },
    grid3: {
      display: 'flex',
      '@media screen and (max-width: 991px)': {
        display: 'block',
      },
      '& > *': {
        margin: theme.spacing(1),
        width: '50%',
        '@media screen and (max-width: 991px)': {
          width: '100%',
        }
      },
    },
    grid4: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
        width: '25%',
      },
    },
    button: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    table: {
      minWidth: 650,
    },
    head: {
      backgroundColor: '#e8f1fd',
    },
    body: {
      fontSize: 11,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  }),
);

interface ProfileCadastrar {
  id: string;
}

interface ParamTypes {
  id: string;
}

type ACLTableRow = { resource: Resource, action: Action[] | '*' };

const resourceOptions: { label: string, value: Resource }[] = [
  {
    label: 'Administradores',
    value: 'Admin',
  },
  {
    label: 'Alertas',
    value: 'Alert',
  },
  {
    label: 'Atividades',
    value: 'Activity',
  },
  {
    label: 'Avisos',
    value: 'WarningType',
  },
  {
    label: 'Blog',
    value: 'Blog',
  },
  {
    label: 'Clientes',
    value: 'Company',
  },
  {
    label: 'Filiais',
    value: 'Branch',
  },
  {
    label: 'Manutenção',
    value: 'Maintenance',
  },
  {
    label: 'Métricas dos Servidores',
    value: 'ServerMetrics',
  },
  {
    label: 'Níveis de alerta',
    value: 'AlertLevel',
  },
  {
    label: 'Perfis',
    value: 'Profile',
  },
  {
    label: 'Produtos',
    value: 'Product',
  },
  {
    label: 'Serviços',
    value: 'Service',
  },
  {
    label: 'Servidores',
    value: 'Server',
  },
  {
    label: 'Clusters',
    value: 'Cluster',
  },
  {
    label: 'Solicitações',
    value: 'Quote',
  },
  {
    label: 'Tipos de alerta',
    value: 'AlertType',
  },

  {
    label: 'Usuários',
    value: 'User',
  },
  {
    label: 'Versão',
    value: 'Version',
  },
  {
    label: 'Logs',
    value: 'Log',
  },
];

const actionOptions: { label: string, value: Action }[] = [
  {
    label: 'Criar',
    value: 'CREATE',
  },
  {
    label: 'Ler',
    value: 'READ',
  },
  {
    label: 'Listar',
    value: 'LIST',
  },
  {
    label: 'Atualizar',
    value: 'UPDATE',
  },
  {
    label: 'Excluir',
    value: 'DELETE',
  },

];

const resourceFormatter = (resource: Resource) => resourceOptions.find(resourceOption => resourceOption.value === resource)?.label || resource;
const actionFormatter = (actions: Action[] | '*') => actions === '*' ? 'Todas' : actions.map(action => actionOptions.find(actionOption => actionOption.value === action)?.label || action).join(', ');

function PerfilCadastrar() {
  const [id, setId] = useState('');
  const params = useParams<ParamTypes>();
  const [name, setName] = useState('');
  const [resource, setResource] = useState<Resource | ''>('');
  const [action, setActions] = useState<Action[]>([]);
  const [rows, setRows] = useState<ACLTableRow[]>([]);

  const [isNew, setIsNew] = useState(false);

  const classes = useStyles();
  const history = useHistory();

  function handleACL() {
    if (resource && action.length > 0) {
      if (!rows.map(row => row.resource).includes(resource)) {
        setRows(rows.concat({
          resource,
          action: action.length === actionOptions.length ? '*' : action,
        }));
      } else {
        Swal.fire({
          title: 'Recurso já adicionado',
          text: 'Exclua a linha do recurso desejado e o adicione novamente para fazer alterações',
          icon: 'warning',
        });
      }
    } else {
      Swal.fire({
        title: 'Atenção',
        text: resource ? 'Selecione as ações desejadas para adicionar a permissão.' : 'Selecione um recurso para adicionar a permissão.',
        icon: 'warning',
      });
    }
  }

  function handleDeleteRow(index: number) {
    setRows([...rows.slice(0, index), ...rows.slice(index + 1)]);
  }

  const handleChangeRecurso = (event: React.ChangeEvent<{ value: unknown }>) => {
    setResource(event.target.value as Resource);
  }

  if (!id) {
    if (params.id) {
      setId(params.id);
    } else {
      setId(uuidv4());
      setIsNew(true);
    }
  }

  useEffect(() => {
    if (!isNew) {
      if (id) {
        const getData = async () => {
          const response = await api.get('/profiles/' + id);
          if (response.status && response.status.toString()[0] === '2') {
            const data = await response.json();

            setName(data.name);
            setRows(data.acl);
          }
        };

        getData();
      }
    }
  }, [id, isNew]);


  async function handleSubmit(e: FormEvent) {
    e.preventDefault();

    try {
      if (!id) {
        Swal.fire({
          title: 'Erro de ID 😢',
          icon: 'error',
        });
        return;
      }

      let result;
      if (isNew) {
        result = await api.put("/profiles", {
          id: id,
          name: name,
          acl: rows,
          enabled: true,
        });
      }
      else {
        result = await api.patch("/profiles/" + id, {
          name: name,
          acl: rows,
          enabled: true,
        });
      }


      if (result.status && result.status.toString()[0] === '2') {
        Swal.fire({
          title: 'Cadastro realizado com sucesso!',
          icon: 'success',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: 'Continuar',
          cancelButtonColor: '#418107',
          cancelButtonText: 'Ver Todos'
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload(false);
          } else {
            history.push('/perfis');
          }
        });
      }
      else {
        Swal.fire({
          title: 'Não foi possível salvar 😢',
          icon: 'error',
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Erro!',
        text: error,
        icon: 'error',
      });
    }

  }

  return (
    <>
      <main>
        <div className="cadastrar">
          <div className="grid-box grid-one">
            <div className="card">
              <div className="card-body">
                <div>
                  <h1>Perfil</h1>
                  <form onSubmit={handleSubmit}>
                    <Input
                      type="hidden"
                      name="id"
                      value={id}
                    />
                    <div className={classes.grid}>
                      <TextField

                        label="Nome"
                        variant="outlined"
                        required
                        name="name"
                        value={name}
                        onChange={(e) => { setName(e.target.value) }}
                      />
                    </div>
                    <br></br>
                    <h2>Permissões</h2>
                    <div className={classes.grid}>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel>Recurso</InputLabel>
                        <Select
                          id="select"
                          value={resource}
                          onChange={handleChangeRecurso}
                          label="Recurso"
                          placeholder="Recurso"
                        >
                          {resourceOptions.map((option, index) => (
                            <MenuItem key={`resource-option-${index}`} value={option.value}>{option.label}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Autocomplete
                        multiple
                        getOptionLabel={(actions) => actions.label}
                        options={actionOptions}
                        onChange={(event, values) => { setActions(values.map(value => value.value)) }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Ações"
                          />
                        )}
                      />
                      <Button
                        className={classes.grid4}
                        variant="contained"
                        color="secondary"
                        size="large"
                        endIcon={<AddIcon />}
                        onClick={() => { handleACL() }}
                      >
                        Adicionar
                      </Button>
                    </div>
                    <div className={classes.grid}>
                      <TableContainer component={Paper}>
                        <Table className={classes.table} size="small" aria-label="a dense table">
                          <TableHead className={classes.head}>
                            <TableRow>
                              <TableCell>Recurso</TableCell>
                              <TableCell>Ações</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody className={classes.body}>
                            {rows.map((row, index) => (
                              <TableRow key={`row-aclitem-${index}`} hover>
                                <TableCell component="th" scope="row" >
                                  {resourceFormatter(row.resource)}
                                </TableCell>
                                <TableCell>{actionFormatter(row.action)}</TableCell>
                                <TableCell align="right" padding="none">
                                  <Tooltip title="Excluir" onClick={() => handleDeleteRow(index)} >
                                    <IconButton aria-label="Excluir" >
                                      <HighlightOffIcon className="delete" />
                                    </IconButton>
                                  </Tooltip></TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    <div className={classes.button}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        startIcon={<SaveIcon />}
                        type="submit"
                      >
                        Salvar
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        startIcon={<BackIcon />}
                        onClick={() => { history.push('/perfis') }}
                      >
                        Voltar
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default PerfilCadastrar;
